import React from 'react';

import {
  LayoutOutlined,
} from '@ant-design/icons';
import { MenuItemType } from 'antd/es/menu/interface';
import { Link, Navigate, Route, Routes } from 'react-router-dom';

import i18n from 'segments/i18n';

import { DashboardLayout } from 'widgets/dashboard-layout';

import CoachesBooking from 'pages/CoachesBooking/CoachesBooking';

const menuItems: MenuItemType[] = [
  {
    key: 'coaches-booking',
    icon: <LayoutOutlined />,
    label: <Link to="/dashboard">{i18n.t('pages.coaches-booking')}</Link>,
  },
];

const DashboardCoach = () => (
  <DashboardLayout sideMenu={menuItems}>
    <Routes>
      {/* <Route element={<h1>{i18n.t('pages.home', 'Главная')}</h1>} /> */}
      <Route index path="dashboard" element={<CoachesBooking />} />
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  </DashboardLayout>
);

export default DashboardCoach;
